<template>
  <svg :class="ineaClass" @mouseenter="fnhover(true)" @mouseleave="fnhover(false)">
    <use v-if="name.length > 0" :href="iconURL" :xlink:href="iconURL" />
    <use
      v-else
      :href="`${iconBaseURL}inea-vue/dgfipicons-sprite.svg#dgfipicon-info`"
      :xlink:href="`${iconBaseURL}inea-vue/dgfipicons-sprite.svg#dgfipicon-info`"
    />
    <title>{{ name.length == 0 ? "impossible d'afficher l'icône" : comment }}</title>
  </svg>
</template>

<script>
/**
 * Composant d'affichage d'icônes issus de sprites SVG Clir. Deux bibliothèques sont proposées nativement : 
 * 
 * * icônes inea
 * * icônes bootstrap 5
 * @author <span><span class="fw-bold">Pascal Ouzeau</span><a class="ms-2" href="mailto:pascal.ouzeau@dgfip.finances.gouv.fr">pascal.ouzeau@dgfip.finances.gouv.fr</a></span>
 * @since <span class="fw-bold">Version 1.0</span>
 * @displayName IneaIcone
 */
export default {
  name: "IneaIcone",
  data() {
    return {
      hover: false
    };
  },
  props: {
    /**
     * Nom de l'icône
     */
    name: { type: String, default: "" },
    /**
     * Taille de l'icône
     * @values xxs, xs, sm, "", md, lg, xl, xxl
     */
    size: {
      type: String,
      default: "",
      validator: value => {
        return (
          ["xxs", "xs", "sm", "", "md", "lg", "xl", "xxl"].indexOf(value) != -1
        );
      }
    },
    /**
     * Couleur de l'icône.
     */
    color: { type: String, default: "" },
    /**
     * Couleur de l'arrière-plan de l'icône
     */
    background: { type: String, default: "" },
    /**
     * Couleur de l'icône lorsqu'il est survolé
     */
    colorHover: { type: String, default: "" },
    /**
     * Couleur de l'arrière-plan de l'icône lorsqu'il est survolé
     */
    backgroundHover: { type: String, default: "" },
    /**
     * Texte à afficher lors du survol de l'icône
     */
    comment: { type: String, default: "" },
    /**
     * Url de l'icône
     */
    url: { type: String, default: "" },
    unclickable : {type:Boolean,default:false}
  },
  computed: {
    iconBaseURL() {
      return process.env.BASE_URL;
    },
    customBaseUrl() {
      return this.handleImage(`${this.url}`);
    },
    iconURL() {
      return this.url.length
        ? `${this.customBaseUrl}#${this.name}`
        : `${this.iconBaseURL}inea-vue/dgfipicons-sprite.svg#${this.name}`;
    },
    ineaClass() {
      return this.hover ? this.classHover : this.classDefault;
    },
    classDefault() {
      return `dgfipicon ${
        this.name.length === 0 ? "noicon" : ""
      } ${this.prefixStringKey(this, "color", {
        prefix: "fill-",
        defaut: ""
      })} ${this.prefixStringKey(this, "background", {
        prefix: "bg-",
        defaut: ""
      })} ${this.prefixStringKey(this, "size", {
        prefix: "dgfipicon-",
        defaut: ""
      })} ${this.unclickable ? 'unclickable' : ''}`;
    },
    classHover() {
      return `dgfipicon ${
        this.name.length === 0 ? "noicon" : ""
      } ${this.prefixStringKey(this, "colorHover", {
        prefix: "fill-",
        defaut: this.color
      })} ${this.prefixStringKey(this, "backgroundHover", {
        prefix: "bg-",
        defaut: this.background
      })} ${this.prefixStringKey(this, "size", {
        prefix: "dgfipicon-",
        defaut: ""
      })} ${this.unclickable ? 'unclickable' : ''}`;
    }
  },
  methods: {
    fnhover(vraioufaux) {
      this.hover = vraioufaux;
    }
  }
};
</script>

<style scoped>
svg {
  cursor: pointer;
}
svg.noicon {
  fill: #aaa;
  background-color: #ddd;
  transform: rotate(180deg);
}
svg.unclickable {
  cursor: default;
}
svg symbol {
  margin: 0;
  padding: 0;
}
</style>

<docs>
```[import](./__example__/IneaIconeExample.vue)
```
</docs>